import { connect } from 'react-redux';
import { getSurvey } from 'selectors';
import FixedBarPlayer from 'components/nav/FixedBarPlayer';

const mapStateToProps = (state, ownProps) => {
  return {
    locationFrom: ownProps.locationFrom,
    location: state.router.location,
    player: state.survey.player,
    survey: getSurvey(state),
  }
}

const TopNavBarPlayer = connect(
  mapStateToProps,
  null,
)(FixedBarPlayer)

export default TopNavBarPlayer;
